import React from 'react'
import { styled } from 'linaria/react'
import { useIntl } from '@jetshop/intl'
import MultiSelectFilterDropdown from './MultiSelectFilterDropdown'
import SortDropdown from './SortDropdown'
import PriceFilterDropdown from './PriceFilterDropdown'
import { useSortOptions } from './sortOptions'
import {
   getStockStatusFilterOptions,
   useStockStatusOptions,
} from './stockStatusOptions'
import { DIGIFI_FILTER_FIELD_NAMES } from '../../DigifiSearch/constants'
import { theme } from '../../Theme'

const ToolbarWrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   gap: 0.5rem 0.75rem;
   padding: 0.75rem;
   background-color: ${theme.colors.white};
   border-radius: 8px;
   box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.04);

   .toolbar-filters {
      display: flex;
      flex-wrap: wrap;
      gap: 0.4rem;
   }

   .toolbar-end {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-left: auto;
   }

   .toolbar-count {
      color: #707070;
      white-space: nowrap;
   }
`

/**
 * Filter toolbar shown above the product grid: brand dropdown, product count and sorting.
 */
const ProductListToolbar = ({
   filters,
   facets,
   metaData,
   updateFilters,
   hideFilters = [],
   className,
}) => {
   const t = useIntl()
   const sortOptions = useSortOptions()
   const stockStatusOptions = useStockStatusOptions()
   const totalCount = metaData?.totalCount ?? 0
   const selectedStockStatuses = [
      filters?.find(
         f => f?.fieldName === DIGIFI_FILTER_FIELD_NAMES.STOCK_STATUS
      )?.value ?? [],
   ].flat()

   return (
      <ToolbarWrapper className={className}>
         <div className="toolbar-filters">
            {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.PRODUCT_TYPE) && (
               <MultiSelectFilterDropdown
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.PRODUCT_TYPE}
                  label={t('Product type')}
                  filters={filters}
                  options={facets?.productTypeFacets}
                  totalCount={totalCount}
                  updateFilters={updateFilters}
                  searchPlaceholder={t('Search product type...')}
                  emptyText={t('No product types found')}
               />
            )}
            {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.BRAND) && (
               <MultiSelectFilterDropdown
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.BRAND}
                  label={t('brand')}
                  filters={filters}
                  options={facets?.brandFacets}
                  totalCount={totalCount}
                  updateFilters={updateFilters}
                  searchPlaceholder={t('Search brand...')}
                  emptyText={t('No brands found')}
               />
            )}
            {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.PRICE) && (
               <PriceFilterDropdown
                  filters={filters}
                  facets={facets}
                  totalCount={totalCount}
                  updateFilters={updateFilters}
               />
            )}
            {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.STOCK_STATUS) && (
               <MultiSelectFilterDropdown
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.STOCK_STATUS}
                  label={t('stock-status')}
                  filters={filters}
                  options={getStockStatusFilterOptions(
                     stockStatusOptions,
                     facets?.stockStatusFacets,
                     selectedStockStatuses
                  )}
                  totalCount={totalCount}
                  updateFilters={updateFilters}
                  searchable={false}
                  sortAlphabetically={false}
               />
            )}
         </div>
         <div className="toolbar-end">
            {metaData && (
               <span className="toolbar-count">
                  {t('{ count, plural, one {# product} other {# products} }', {
                     count: totalCount,
                  })}
               </span>
            )}
            {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.SORT_BY) && (
               <SortDropdown
                  filters={filters}
                  options={sortOptions}
                  updateFilters={updateFilters}
               />
            )}
         </div>
      </ToolbarWrapper>
   )
}

export default ProductListToolbar
